export const userGuides = (language: string) => {
	return {
		url: `connect/${language === 'en' ? 'ebu_en' : 'ebu_ar'}/content?srv=cmpnt&cmpntname=user_guide&source=library`,
	};
};
